export default __webpack_public_path__ + "static/media/ic_launcher.efbc8152.png";